export const downloadQrCode = (id) => {
  const canvas = document.getElementById("qrcode");
  if (canvas) {
    canvas.toBlob((blob) => {
      const url = URL.createObjectURL(blob);
      const downloadLink = document.createElement("a");
      downloadLink.href = url;
      downloadLink.download = `${id}.png`;
      document.body.appendChild(downloadLink);
      downloadLink.click();
      document.body.removeChild(downloadLink);
      URL.revokeObjectURL(url);
    }, "image/png");
  } else {
    console.error("QR code canvas element not found.");
  }
};

export const downloadQrCodeAsSvg = (id) => {
  const svg = document.getElementById("qrcode-svg");

  if (!svg) {
    console.error("QR code SVG element not found.");
    return;
  }

  const serializer = new XMLSerializer();
  let source = serializer.serializeToString(svg);

  // Ensures the SVG file is self-contained and clearly identified as SVG when opened outside the browser.
  if (!source.match(/^<svg[^>]+xmlns="http:\/\/www\.w3\.org\/2000\/svg"/)) {
    source = source.replace(
      "<svg",
      '<svg xmlns="http://www.w3.org/2000/svg"'
    );
  }

  // Optional; added for maximum compatibility with XML parsers and some tools, but not required for browsers.
  if (!source.startsWith('<?xml')) {
    source = '<?xml version="1.0" standalone="no"?>\r\n' + source;
  }

  const blob = new Blob([source], {
    type: "image/svg+xml;charset=utf-8",
  });

  const url = URL.createObjectURL(blob);
  const downloadLink = document.createElement("a");
  downloadLink.href = url;
  downloadLink.download = `${id}.svg`;
  document.body.appendChild(downloadLink);
  downloadLink.click();
  document.body.removeChild(downloadLink);
  URL.revokeObjectURL(url);
};

